import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        galleryModalHeader: {
            alignSelf: 'end',
            paddingTop: {base: remCalc(12), md: remCalc(24), lg: remCalc(40)},
            paddingBottom: {lg: remCalc(0)},
            paddingRight: {base: remCalc(12), md: remCalc(24), lg: remCalc(40)},
            color: 'background.dark',
            layerStyle: {lg: 'full-width'},
            width: {lg: '100%'},
            margin: {lg: '0 auto'},
            display: {lg: 'flex'},
            justifyContent: {lg: 'end'},
        },
        galleryModalBody: {
            alignContent: 'center',
            layerStyle: {lg: 'full-width'},
            width: {lg: '100%'},
            margin: {lg: '0 auto'},
            paddingBottom: {base: remCalc(12), md: remCalc(24), lg: remCalc(0)},
            px: remCalc(0),
            pt: remCalc(0),
        },
    },
    parts: ['galleryModalContainer'],
}
